import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH, MOBILE_S_WIDTH } from '../globalUtils';

import { ReactComponent as UmbrellaSVG } from '../../icons/Umbrella.svg'
import InsBG from '../../images/ins-bg.jpg';
import InsBGL from '../../images/ins-bg-low.jpg';
import InsBGTablet from '../../images/ins-bg-tablet.jpg';
import InsBGTabletL from '../../images/ins-bg-tablet-low.jpg';
import InsBGMobile from '../../images/ins-bg-mobile.jpg';
import InsBGMobileL from '../../images/ins-bg-mobile-low.jpg';

export const InsuranceContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    align-items: center;
`;

export const TopContainer = styled.div`
    width: 100%;
    height: 566px;
    background-image: url(${InsBG}), url(${InsBGL});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        background-image: url(${InsBGTablet}), url(${InsBGTabletL});
          height: 528px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        background-image: url(${InsBGMobile}), url(${InsBGMobileL});
        height: 469px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        height: 418px;
    }
`;

export const Area = styled.div`
    width: ${DESKTOP_WIDTH}px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: ${TABLET_WIDTH}px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: ${MOBILE_WIDTH}px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: ${MOBILE_S_WIDTH}px;
    }
`;

export const TopText = styled.div`
    color: #003a70;
    font-size: 44px;
    padding: 120px 0 45px;
    width: 520px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 40px;
        padding: 85px 0 10px;
        width: 406px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 20px;
        padding: 31px 0 287px;
        text-align: center;
        font-weight: 600;
        width: 90%;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 18px;
        padding: 28px 0 255px;
    }
`;

export const RedText = styled.div`
    color: #ff4438;
`;

export const CTAButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 59px;
    width: 322px;
    background-color: #003a70;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #f1efef;
    font-size: 23px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 61px;
        background-color: #003a70;
        border: 1px solid rgb(0, 58, 112);
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 36px;
        width: 215px;
        border-radius: 3.6px;
        box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.5);
        font-size: 16px;
        align-self: center;
    }
`;

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 0 auto;
    position: relative;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        align-items: center;
    }
`;

export const UmbrellaIcon = styled(UmbrellaSVG)`
    margin: 23px 0;
    height: 39px;
    width: 47px;
    align-self: center;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: 38px;
        height: 31px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 33px;
        height: 27px;
        margin: 15px 0;
    }
`;

export const DescriptionText = styled.div`
    color: #003a70;
    align-self: center;
    font-size: 20px;
    text-align: center;
    width: 824px;
    margin-bottom: 51px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 16px;
        width: 707px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 14px;
        width: 324px;
        margin-bottom: 35px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 288px;
        margin-bottom: 27px;
    }
`;

export const Title = styled.div`
    position: relative;
    color: #003a70;
    font-size: 48px;
    font-weight: 600;
    margin: 87px 0 37px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 33px;
        font-weight: 400;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 24px;
        margin: 35px 0 27px;
        align-self: center;
    }    
`;

export const RedStripe = styled.div`
    position: absolute;
    top: 0;
    right: 2px;
    height: 9px;
    width: 25px;
    background-color: #ff4438;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 6px;
        width: 18px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 4px;
        width: 13px;
        right: calc(50% - 6.5px)
    }
`;